import { render } from "./DetalhesAberturaCaixa.vue?vue&type=template&id=292e6a62&scoped=true&ts=true"
import script from "./DetalhesAberturaCaixa.vue?vue&type=script&lang=ts"
export * from "./DetalhesAberturaCaixa.vue?vue&type=script&lang=ts"

import "./DetalhesAberturaCaixa.vue?vue&type=style&index=0&id=292e6a62&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292e6a62"]])

export default __exports__